import { z } from 'zod';

import { PrincipalModificationId } from '../BrandedIds';
import { BaseUpsertTransactionSideEffect } from './BaseUpsertTransactionSideEffect';

export const UpsertPrincipalModificationSideEffectContext = BaseUpsertTransactionSideEffect.extend({
  principalModificationId: PrincipalModificationId,
});
export const UpsertPrincipalModificationSideEffect = UpsertPrincipalModificationSideEffectContext.extend({
  type: z.literal('upsertPrincipalModification'),
});
export type UpsertPrincipalModificationSideEffect = z.infer<typeof UpsertPrincipalModificationSideEffect>;
